import React__default, { useContext } from 'react';

var TimeZoneContext = React__default.createContext(undefined);
var TimeZoneContextProvider = TimeZoneContext.Provider;
var TimeZoneContextConsumer = TimeZoneContext.Consumer;

var useTimeZoneContext = function useTimeZoneContext() {
  var timeZoneContext = useContext(TimeZoneContext);

  if (!timeZoneContext) {
    throw new Error('Invoked `TimeZoneContext` outside of provider');
  }

  return timeZoneContext;
};

export { TimeZoneContext, TimeZoneContextConsumer, TimeZoneContextProvider, useTimeZoneContext };
//# sourceMappingURL=index.js.map
